'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _PricingSelectors = require('pricing-pages-unified-ui/selectors/PricingSelectors');

var _CurrencySelectors = require('pricing-pages-unified-ui/selectors/CurrencySelectors');

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _RequiredOnboardingSubtext = require('pricing-pages-unified-ui/components/calculator/RequiredOnboardingSubtext');

var _RequiredOnboardingSubtext2 = _interopRequireDefault(_RequiredOnboardingSubtext);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RequiredOnboardingSection = function RequiredOnboardingSection(_ref) {
  var activeCurrencyCode = _ref.activeCurrencyCode,
      requiredOnboardingMerchId = _ref.requiredOnboardingMerchId,
      calculatedPrice = _ref.calculatedPrice;

  if (requiredOnboardingMerchId) {
    var billingNameKey = _ImmutableMerchandiseIdMap2.default[requiredOnboardingMerchId].billingNameKey;
    return _react2.default.createElement(_RequiredOnboardingSubtext2.default, {
      billingNameKey: billingNameKey,
      price: calculatedPrice,
      currencyCode: activeCurrencyCode
    });
  }
  return null;
};

RequiredOnboardingSection.propTypes = {
  requiredOnboardingMerchId: _react.PropTypes.number,
  //from connect
  activeCurrencyCode: _react.PropTypes.string.isRequired,
  calculatedPrice: _react.PropTypes.number
};

var mapStateToProps = function mapStateToProps(state, _ref2) {
  var requiredOnboardingMerchId = _ref2.requiredOnboardingMerchId,
      activeTermId = _ref2.activeTermId;

  var pricingInfo = requiredOnboardingMerchId ? (0, _PricingSelectors.calculatedPriceSelector)(state, {
    termId: activeTermId,
    itemConfigurations: [{ merchandiseId: requiredOnboardingMerchId, quantity: 1 }]
  }) : null;

  var calculatedPrice = pricingInfo && pricingInfo.oneTimeFee ? pricingInfo.oneTimeFee.calculatedPrice : null;

  return {
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    calculatedPrice: calculatedPrice
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(RequiredOnboardingSection);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/calculator/RequiredOnboardingSection.js
// module id = 592
// module chunks = 3 4